import Layout from "components/structure/Layout";
import React, { useCallback } from "react";
import AccessTable from "../Common/AccessTable";
import { Box, Button, InputAdornment, TextField } from "@mui/material";
import Delegation from "assets/delegation.svg";
import AddButton from "assets/add.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import AdministratorService from "services/AdministratorService";
import { useContext } from "react";
import { SnackbarContext } from "context/snackBarContext";
import { useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { debounce } from "lodash";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { AuthData } from "auth/AuthWarpper";
import RoleService from "services/RoleService";
import { useTranslation } from "react-i18next";
const AdministratorCreation = () => {
  const navigate = useNavigate();
  const {t,i18n} = useTranslation()
  const { user } = AuthData();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const [data, setData] = useState([]);
  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await AdministratorService.getRole();

      const responseData = response.data.response;


      const rows = responseData.map((item) => ({
        profileId: item.profileId,
        profileCode: item.profileCode,
        profileName: item.profileName,
        isActive: item.isActive === true ? "Active" : "Inactive",
        profileAttribute: item.profileAttribute,
        isDeleted: item.isDeleted,
        createdByUser: item.createdByUser,
        modifiedDateTimeUTC: item.modifiedDateTimeUTC,
        modifiedByUser: item.modifiedByUser,
        profileOwnerId: item.profileOwnerId,
        profileOwnerName: item.profileOwnerName,
        roleFunctionality:item?.functionalities?.map((ele) => ele?.functionality_name).join(', '),
        roleFunctionalityOriginal:item?.functionalities,
        serviceNumber: item.serviceNumber,
        remarks: item.remarks,
        countries: item.countries ? item.countries?.map((ele) => ele?.countryName).join(', '):""
      }));
      setData(rows);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);



  const fetchResults = useCallback(
    debounce(async (query) => {
      setLoading(true);
      try {
        const response = await AdministratorService.searchRole(query);

        const responseData = response.data.response;


        const rows = responseData.map((item) => ({
          profileId: item.profileId,
          profileCode: item.profileCode,
          profileName: item.profileName,
          isActive: item.isActive === true ? "Active" : "Inactive",
          profileAttribute: item.profileAttribute,
          isDeleted: item.isDeleted,
          createdByUser: item.createdByUser,
          modifiedDateTimeUTC: item.modifiedDateTimeUTC,
          modifiedByUser: item.modifiedByUser,
          profileOwnerId: item.profileOwnerId,
          profileOwnerName: item.profileOwnerName,
          roleFunctionality: item.roleFunctionality ? item.roleFunctionality.join(', ') : '',
          serviceNumber: item.serviceNumber,
          remarks: item.remarks,
          countries: item.countries ? item.countries?.map((ele) => ele?.countryName).join(', '):""
        }));
        setData(rows);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error.message);
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setData([]);
      }
    }, 500), // 500ms debounce delay
    [] // Ensure the debounce function is only created once
  );

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      fetchResults(query);
    }
    else{
      fetchData();
    }
  };

  const columns = [
    { label: t("administratorAccess.roleName"), field: "profileName", align: "left" }, // Role Name localized with administratorAccess
    { label: t("userCreation.country"), field: "countries", align: "left" },
    { label: t("administratorAccess.attribute"), field: "profileAttribute", align: "left" },
    { label: t("administratorAccess.profileOwnerName"), field: "profileOwnerName", align: "left" }, // Role Owner localized with administratorAccess
    { label: t("administratorAccess.roleFunctionality"), field: "roleFunctionality", align: "left"}, // Assigned Functionality localized with administratorAccess
    { label: t("Status"), field: "isActive", align: "left" }, // Status without administratorAccess
    { label: t("Action"), field: "action", align: "left" } // Action without administratorAccess
  ];
  
  

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Box>
              <TextField
                sx={{ width: "403px" }}
                fullWidth
                value={searchQuery}
                onChange={handleSearch}
                placeholder={t("search")}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box>
              <Button
                // variant="outlined"
                sx={{
                  mr: 2,
                  width: 187,
                  height: 51,
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                }}
                startIcon={<img src={Delegation} alt="delegation" />}
                onClick={() => navigate('/selfDelegationList', { state: { fromUrl: "administratorCreation" } })}
              //roleDelegation
              >
                {t("delegation")}
              </Button>
              <Button
                // variant="outlined"
                onClick={() => navigate("/addAdministratorCreation")}
                sx={{
                  width: 187,
                  height: 51,
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                  color: "#0A3575",
                  fontWeight: 500,
                  borderRadius: "11px",
                }}
                startIcon={<img src={AddButton} alt="add" />}
              >
                {t("addNewRole")}
              </Button>
            </Box>
          </Box>

          <AccessTable
            columns={columns}
            rows={data}
            url={"/editadministratorCreation"}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 5,
              mb: 2,
            }}
          >
            <Button
              sx={{
                borderRadius: 2,
                background: "#EF7D00",
                color: "#ffffff",
                fontWeight: 600,
                height: 54,
                width: { xs: "100%", md: "156px" },
                "&:hover": {
                  backgroundColor: "#EF7D00",
                },
              }}
              onClick={() => navigate("/export", { state: 'administrator',profileInfo:user?.profileAttribute , extractType:'role'})}
            >
              {t("export")}
            </Button>
          </Box>
        </Box>
      </Box>
    </LayoutAccessManagement>
  );
};

export default AdministratorCreation;
